export default Object.freeze({
  // accumulation
  MALLARR_ONE: '샘플몰',
  MALLARR_TWO: '아이엠스쿨 샵',
  MALLARR_THREE: '유니원몰',
  TITLE: '적립금 관리',
  TITLE_TAB_ONE: '적립금설정관리',
  TITLE_TAB_TWO: '적립금 지급관리',
  TITLE_TAB_THREE: '적립금 적립/차감 조회',
  DETAIL_ONE: '적립금 적립/차감 조회는 전일 23시 59분 59초 기준 입니다.',
  DETAIL_TWO: '쇼핑몰 별로 설정된 단위 관계없이 숫자 합산으로 표기 됩니다.',
  DETAIL_THREE: '운영자가 지급한 적립금은 적립 항목 합산 처리 됩니다.',
  DETAIL_FOUR: '탈퇴회원의 적립금은 차감 항목 합산 처리 됩니다.',
  DETAIL_FIVE: '조회 시점에 따라 합산된 적립/잔액 값이 일부 상이할 수 있습니다.',
  SEARCH_MALL_TITLE: '쇼핑몰',
  SEARCH_DATE_TITLE: '기간',
  SEARCH_DATE_MONTH_SELECT: '월별',
  SEARCH_DATE_PERIOD_SELECT: '일별',
  DATE_YEAR: '년',
  DATE_MONTH: '월',
  TOP_TABLE_TITLE: '적립금 합계',
  BOTTOM_TABLE_TITLE: '일별 적립금 합계',
  TABLE_PAGESIZE: '개 보기',
  EXCEL_DOWNLOAD_ONE: '그룹별 다운로드',
  EXCEL_DOWNLOAD_TWO: '등급별 다운로드',
  TOP_TABLE_COMPLEX_HEADER_ONE: '전체 적립금 합계',
  TOP_TABLE_COMPLEX_HEADER_TWO: '조회기간 적립금 합계',
  TOP_TABLE_HEADER_ONE: '적립',
  TOP_TABLE_HEADER_TWO: '차감',
  TOP_TABLE_HEADER_THREE: '잔액',
  BOTTOM_TABLE_HEADER_ONE: '쇼핑몰',
  BOTTOM_TABLE_HEADER_TWO: '날짜',
  BOTTOM_TABLE_HEADER_THREE: '적립',
  BOTTOM_TABLE_HEADER_FOUR: '차감',
  BOTTOM_TABLE_HEADER_FIVE: '상세보기',

  MEMBER_NO: '회원번호',
  REGISTER_ADMIN_NAME: '변경자',
  STATUS: '구분',
  DETAIL_RESEAN: '사유',
  GIVE: '적립',
  SUBSTRUC: '차감',
  DATE: '날짜',
  POP_TITLE: '회원정보',
  THE_AMOUNT: '적립금 적립',
  D_AMOUNT: '적립금 차감',
  THE_POP_TITLE: '일별 적립금 조회 상세',
  NO_DATA: '조회 결과가 없습니다.',
  MEMBER_GRADE_NAME: '회원등급',
  MEMBER_GROUP_NAME: '회원그룹',
  MEMBER_NAME: '회원명',
  MEMBER_ID: '회원아이디',
  ACCUMULAGION_STATUS_NAME: '구분',
  REASON_DETAIL: '사유',
  ADD_ACCUMULATION: '적립',
  SUB_ACCUMULATION: '차감',
  ORDER_NO: '주문번호',
  ORDER_YMDT: '주문일자',
  PAYMENT_ACCUMULATION: '적립금지급',
  REQUEST_NO: '적립금번호',
  PAYMENT_YMDT: '지급일자',
  ADD_REGISTER_YMDT: '적립일자',
  SUB_REGISGER_YMDT: '차감일자',
  NO_DATA_2: '검색 결과가 없습니다.'
});
